var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-flex flex-column" }, [
    _c("div", { staticClass: "sidebar-top" }, [
      _c(
        "div",
        { staticClass: "stacked-nav" },
        [
          _c("router-link", {
            attrs: { to: { name: "Stage", params: { uuid: _vm.id } } },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "stack-item",
                        class: [isActive && "", isExactActive && "active"],
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "40",
                              height: "40",
                              viewBox: "0 0 28 28",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M4.507 6.008A3.243 3.243 0 0 0 3 8.75v10.5c0 2.9 2.35 5.25 5.25 5.25h10.5a3.247 3.247 0 0 0 2.744-1.508l-.122.006l-.122.002h-13a3.75 3.75 0 0 1-3.75-3.75v-13c0-.081.002-.162.007-.242M8.75 3A3.25 3.25 0 0 0 5.5 6.25v12.5A3.25 3.25 0 0 0 8.75 22h12.5a3.25 3.25 0 0 0 3.25-3.25V6.25A3.25 3.25 0 0 0 21.25 3zm-.582 17.401l6.307-6.178a.75.75 0 0 1 .966-.07l.084.07l6.306 6.178a1.749 1.749 0 0 1-.581.099H8.75c-.204 0-.4-.035-.582-.099M8.75 4.5h12.5c.966 0 1.75.784 1.75 1.75v12.5c0 .208-.036.408-.103.593l-6.322-6.191a2.25 2.25 0 0 0-3.02-.117l-.13.117l-6.322 6.192A1.747 1.747 0 0 1 7 18.75V6.25c0-.966.784-1.75 1.75-1.75m2.75 3.251a1.25 1.25 0 1 0 0 2.499a1.25 1.25 0 0 0 0-2.499",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Welcome")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("router-link", {
            attrs: {
              to: {
                name: "StageInpaint",
                params: { uuid: _vm.id, activeStageId: _vm.activeStage.id },
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({
                  href,
                  route,
                  navigate,
                  isActive,
                  isExactActive,
                }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "stack-item",
                        class: [
                          isActive && "active",
                          isExactActive && "active",
                        ],
                        on: { click: navigate },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "40",
                              height: "40",
                              viewBox: "0 0 20 20",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d: "M14 7.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0a.5.5 0 0 0 1 0M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.003c-.341.016-.68.092-1 .229V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8.826a.2.2 0 0 0 .34.142l.807-.796l-.002-.003l1.048-1.03l.206-.202l2.55-2.505a1.5 1.5 0 0 1 2.102 0l1.745 1.714l-.707.708l-1.739-1.709a.5.5 0 0 0-.7 0l-2.756 2.707l-1.851 1.828c-.758.748-2.043.21-2.043-.854zm.4 11.035c.369.184.83.335 1.217.25c.251-.056.577-.193.943-.347c.885-.373 2.003-.843 2.862-.497c.637.256.584.981.405 1.33c-.035.066-.008.16.065.177a4.6 4.6 0 0 0 1.112.088a.917.917 0 0 1 .023-.14l.375-1.498a2.18 2.18 0 0 1 .578-1.02l4.83-4.83a1.87 1.87 0 1 1 2.644 2.645l-4.83 4.829a2.197 2.197 0 0 1-1.02.578l-1.222.305c-1.121.328-2.794.222-3.313-.183c-.449-.35-.467-.887-.316-1.244c.034-.08-.026-.183-.111-.17c-.495.07-.9.25-1.3.427c-.585.26-1.156.513-1.976.411c-.711-.088-1.107-.459-1.325-.825c-.122-.204.147-.392.36-.286",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("trans")("Inpainting")) +
                            " "
                        ),
                        _c("span", { staticClass: "badge bg-info px-2" }, [
                          _vm._v("AI"),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-bot btn-box" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }